<template>
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Cambiar contraseña</h3>
            </div>
          </div>
          <div class="card-body">
            <form ref="profile_form" @submit.prevent="handleChangePassword">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-password-input
                        v-model="old_password"
                        name="old_password"
                        autocomplete="on"
                        class="mb-3"
                        prepend-icon="fa fa-key"
                        placeholder="Contraseña actual"
                      />
                      <validation-error
                        :errors="apiValidationErrors.old_password"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-password-input
                        v-model="password"
                        name="new_password"
                        autocomplete="on"
                        class="mb-3"
                        prepend-icon="fa fa-key"
                        placeholder="Nueva contraseña"
                      />
                      <validation-error
                        :errors="apiValidationErrors.password"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-password-input
                        v-model="password_confirmation"
                        name="confirm_password"
                        autocomplete="on"
                        class="mb-3"
                        prepend-icon="fa fa-key"
                        placeholder="Repetir nueva contraseña"
                      />
                      <validation-error
                        :errors="apiValidationErrors.password_confirmation"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="my-2 text-right">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Cambiar contraseña
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/BaseButton.vue";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";

export default {
  name: "UserPasswordCard",

  components: {
    BaseButton,
    ValidationError,
  },

  mixins: [formMixin],

  props: {
    user: Object,
  },

  data() {
    return {
      old_password: null,
      password: null,
      password_confirmation: null,
    };
  },

  methods: {
    async handleChangePassword() {
      if (!this.password || !this.password_confirmation || !this.old_password) {
        this.$notify({
          type: "danger",
          message: "Todos los campos son obligatorios.",
        });
      } else {
        if (this.password == this.password_confirmation) {
          var obj = {
            currentPassword: this.old_password,
            password: this.password,
            passwordConfirmation: this.password_confirmation,
          };

          console.log(obj);

          try {
            await this.$store.dispatch("reset/changePassword", obj);
            /*     this.$refs["password_form"].reset();
            this.resetApiValidation(); */

            this.password = null;
            this.password_confirmation = null;
            this.old_password = null;

            this.$notify({
              type: "success",
              message: "Contraseña actualizada correctamente.",
            });
          } catch (error) {
            this.$notify({
              type: "danger",
              message: "Oops, algo ha ido mal!",
            });
            this.setApiValidation(error.response.data.errors);
          }
        } else {
          this.$notify({
            type: "danger",
            message: "La nueva contraseña se debe repetir exactamente igual.",
          });
          this.setApiValidation(error.response.data.errors);
        }
      }
    },
  },
};
</script>
